export const SET_VIRTUAL_BUNDLES_REQUEST_PENDING = 'SET_VIRTUAL_BUNDLES_REQUEST_PENDING'
export const SET_VIRTUAL_BUNDLES_REQUEST_SUCCESS = 'SET_VIRTUAL_BUNDLES_REQUEST_SUCCESS'
export const SET_VIRTUAL_BUNDLES_REQUEST_FAILURE = 'SET_VIRTUAL_BUNDLES_REQUEST_FAILURE'
export const SET_SELECTED_VIRTUAL_BUNDLE_DETAILS = 'SET_SELECTED_VIRTUAL_BUNDLE_DETAILS'
export const GET_A_VIRTUAL_BUNDLE_DATA_SUCCESS = 'GET_A_VIRTUAL_BUNDLE_DATA_SUCCESS'
export const SET_VIRTUAL_BUNDLES_FROM_ITEMS = 'SET_VIRTUAL_BUNDLES_FROM_ITEMS'
export const GET_A_VIRTUAL_BUNDLES_REQUEST_PENDING = 'GET_A_VIRTUAL_BUNDLES_REQUEST_PENDING'
export const GET_A_VIRTUAL_BUNDLES_REQUEST_SUCCESS = 'GET_A_VIRTUAL_BUNDLES_REQUEST_SUCCESS'
export const SET_VIRTUAL_BUNDLE_PARENT = 'SET_VIRTUAL_BUNDLE_PARENT'
export const SHOW_VIRTUAL_BUNDLE_POPUP = 'SHOW_VIRTUAL_BUNDLE_POPUP'
export const CLOSE_VIRTUAL_BUNDLE_POPUP = 'CLOSE_VIRTUAL_BUNDLE_POPUP'
export const VIRTUAL_BUNDLE_CALL_EDIT_FIELDS_API = 'VIRTUAL_BUNDLE_CALL_EDIT_FIELDS_API'
export const SET_VIRTUAL_BUNDLES_PAGE = 'SET_VIRTUAL_BUNDLES_PAGE'
export const SET_VIRTUAL_BUNDLES_ROWS_PER_PAGE = 'SET_VIRTUAL_BUNDLES_ROWS_PER_PAGE'
export const SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_PENDING = 'SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_PENDING'
export const SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_SUCCESS = 'SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_SUCCESS'